import React from "react";

//import MapboxDirections from  '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions'
import 'mapbox-gl/dist/mapbox-gl.css';
import 'mapbox-gl-controls/lib/controls.css';
import '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.css'

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



const MapWrapperGoogle = ({handleLonLat = ( ) => {},setSearch, height = '100%', lngLat={lng: 0, lat: 0}, zoom = 14, draggable=true, classNameInput=''}) => {

  const mapRef = React.useRef(null);
  const mapClssRef = React.useRef(null);
  //let marker = React.useRef(null)
  const [address, setAddress] = React.useState("");
  const handleSelect = async value => {
    //const google = window.google
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    setAddress(value);
    handleLonLat({lat:latLng.lat , lng: latLng.lng, place: value})
    
    mapClssRef.current.setCenter({lat:latLng.lat , lng: latLng.lng})
    mapClssRef.current.setZoom(12)
    //var latlng = new google.maps.LatLng(latLng.lat, latLng.lng);
    //marker.current.setPosition(latlng)
  };
  React.useEffect(() => {
    
    let google = window.google;
    let map = mapRef.current;
    map.style.height = '100%'
    let lat = 0;
    let lng = 0;
    //const myLatlng = new google.maps.LatLng(lat, lng);
    const myLatlng = { lat, lng };
    const mapOptions = {
      scrollwheel: true, //we disable de scroll over the map, it is a really annoing when you scroll through page
      center: lngLat || myLatlng,
      disableDefaultUI:true,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      rotateControl: false,
      zoom: zoom,
    };

    map = new google.maps.Map(map, mapOptions);
    mapClssRef.current= map

    /*marker.current = new google.maps.Marker({
      position: myLatlng,
      map: map,
      draggable: draggable,
      animation: google.maps.Animation.DROP,
      title: "Elige tu ubicación!",
    });
    marker.current.addListener('dragend' , (marker => {
      var markerLatLng = marker.latLng
      handleLonLat({lat: markerLatLng.lat() , lng: markerLatLng.lng()})
    }))*/
    //revice en el codigo y siempre es true la validacion sobra
    //if(draggable) {
      /*
            mapClssRef.current.addListener("center_changed", (e) => {
              
              var latlng =mapClssRef.current.center
              marker.current.setPosition(latlng)
              
            });*/
            mapClssRef.current.addListener("dragend", (e) => {
              
              //var latlng =mapClssRef.current.center
              //marker.current.setPosition(latlng)
              
              handleLonLat({lat: mapClssRef.current.center.lat() , lng: mapClssRef.current.center.lng(), })
            });
          //}

    /*const contentString =
      '<div class="info-window-content"><h2>BLK Dashboard React</h2>' +
      "<p>A freebie Admin for ReactStrap, Bootstrap, React, and React Hooks.</p></div>";

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    google.maps.event.addListener(marker.current, "click", function () {
      infowindow.open(map, marker.current);
    });*/
  }, [handleLonLat,zoom]);

  React.useEffect(() => {
    //marker.current.setPosition(lngLat)
    
    mapClssRef.current.setCenter(lngLat)
    return () => {
      
    }
  }, [lngLat])
  return <>
     {setSearch && <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className={classNameInput}>
            <input type='search' id="place" {...getInputProps({ placeholder: "Escribe una dirección" })} />

            <ul style={{zIndex: 300}} className={`optionsSearch p-0 ${suggestions.length===0&&  'border-0'}`}> 
              {suggestions.map(suggestion => {
                  const style = {
                      fontSize: '10px',
                      textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'all .3s linear'
                  };
                  return (
                  <li className='optionAutoComplete' {...getSuggestionItemProps(suggestion, { style })}>
                      {suggestion.description}
                  </li>
                  
                  );
              })}
              {(!loading) ? <></> : 
                  <div className='d-flex justify-content-center' style={{color: '#E5E9F2' ,fontSize: '50px', width:'100%'}}>
                  <FontAwesomeIcon spin icon='circle-notch'/>
              </div>
              }
            </ul>
          </div>
        )}
      </PlacesAutocomplete>} 
    <div ref={mapRef} />
    </>;
  };
  export default React.memo(MapWrapperGoogle, () => false)